module.exports = __webpack_public_path__ + "ef4cd15fb130c2d9588b52c5619635da.MP3";